import type fetchCleaningState from '../../../../hosting-server/src/booking/functions/fetchCleaningState';
import { createServerQueryHook } from '../../core/hooks/serverHooksCreators';

const useCleaningState =
    createServerQueryHook<typeof fetchCleaningState>('fetchCleaningState');

export default useCleaningState;
